module.exports = __webpack_public_path__ + "img/organization-announcement.1af1f973.png";